/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { HandAndMachineBendFamilyInformationModule } from './hand-and-machine-bend-family-information.module';
export { HandAndMachineBendFamilyInformation } from './hand-and-machine-bend-family-information.component';